// extracted by mini-css-extract-plugin
export default {"container":"Wj-z","disabled":"Xj-z","subtotal":"Yj-z","legal":"Zj-z"};